import {BaseComponentLifecycleEventHandler} from "../../../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import type {FullGameDataSource} from "../../../../../domain/full-game/models/full-game-data-source";

// Bridges the game-center feed's WSC story into app-level state so the website frame can render the
// single WSC floating button (thumbnail from the feed; tapping it opens the native Blaze player).
// Set when the game data source is populated; cleared on unload so the button never lingers after
// navigating away from the game page.
export class GameCenterIndexPageWscStoryHandler extends BaseComponentLifecycleEventHandler {

  onDataSourcePopulated(dataSource: FullGameDataSource) {
    super.onDataSourcePopulated(dataSource);

    this.appStore.state.setWscFloatingStory(dataSource?.game?.wscStory);
  }

  onUnloaded(controller) {
    super.onUnloaded(controller);

    this.appStore.state.setWscFloatingStory(null);
  }
}
